import React, { useState } from 'react';
import {
    Card,
    Grid,
    TextField,
    Box,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Button,
    Typography, IconButton
} from "@mui/material";
import Autocomplete from '@mui/material/Autocomplete';
import { DataGrid } from '@mui/x-data-grid';
import { Edit, Delete } from '@mui/icons-material';
const Communication = () => {
    const planOptions = ["Basic Plan", "Premium Plan", "Enterprise Plan"];
    const frequencyOptions = ["Monthly", "Quaterly", "Halfyearly", "Yearly", "Unlimited"];
    const creditOptions = ["1 Credit", "5 Credits", "10 Credits"];

    const [formData, setFormData] = useState({
        communicationType: '',
        plan: '',
        frequency: '',
        perCredit: ''
    });
    const [submittedData, setSubmittedData] = useState([]);

    const handleChange = (event, value, field) => {
        setFormData({ ...formData, [field]: value || event.target.value });
    };

    const handleSubmit = () => {
        setSubmittedData([...submittedData, formData]);
        setFormData({ communicationType: '', plan: '', frequency: '', perCredit: '' });
    };

    const columns = [
        { field: "sno_id", headerName: "S.No", align: "center", headerAlign: "center", width: 80 },
        { field: "communicationtype", headerName: "Communication Type", align: "center", headerAlign: "center", flex: 1 },
        { field: "plan", headerName: "Plan", align: "center", headerAlign: "center", flex: 1 },
        { field: "frequency", headerName: "Frequency", align: "center", headerAlign: "center", flex: 1 },
        { field: "percredit", headerName: "Per Credit", align: "center", headerAlign: "center", flex: 1 },
        {
            field: "actions",
            headerName: "Actions",
            align: "center",
            headerAlign: "center",
            width: 120,
            renderCell: (params) => (
                <>
                    <IconButton color="primary" onClick={() => handleEdit(params.row.id)}>
                        <Edit />
                    </IconButton>
                    <IconButton color="primary" onClick={() => handleDelete(params.row.id)}>
                        <Delete />
                    </IconButton>
                </>
            ),
        }
    ];

    const rows = [
        { id: 1, sno_id: 1, communicationtype: "Email", plan: "Basic", frequency: "Monthly", percredit: "1000" },
        { id: 2, sno_id: 2, communicationtype: "SMS", plan: "Standard", frequency: "Monthly,Yearly", percredit: "388" },
        { id: 3, sno_id: 3, communicationtype: "Whatsapp", plan: "Premium", frequency: "Monthly,Unlimited", percredit: "100" },
        { id: 4, sno_id: 4, communicationtype: "Email", plan: "Enterprise", frequency: "Monthly,Quaterly", percredit: "566" },
        { id: 5, sno_id: 5, communicationtype: "SMS", plan: "Basic", frequency: "Monthly", percredit: "700" }
    ];

    const handleEdit = (id) => {
        console.log("Edit clicked for ID:", id);
    };

    const handleDelete = (id) => {
        console.log("Delete clicked for ID:", id);
    };

    return (
        <Box sx={{ p: 2 }}>
            <Card elevation={3} sx={{ p: 3, mb: 2 }}>
                <Typography sx={{ mb: 2, color: '#a00', fontSize: '20px', fontWeight: '600' }}>
                    Communication Channel
                </Typography>
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} md={3}>
                        <FormControl fullWidth sx={{ height: "56px" }}>
                            <InputLabel>Communication Type</InputLabel>
                            <Select
                                name="communicationType"
                                value={formData.communicationType}
                                onChange={(e) => handleChange(e, null, 'communicationType')}
                            >
                                <MenuItem value="sms">SMS</MenuItem>
                                <MenuItem value="email">Email</MenuItem>
                                <MenuItem value="whatsapp">WhatsApp</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    
                    <Grid item xs={12} md={3}>
                        <Autocomplete
                            fullWidth
                            disablePortal
                            options={planOptions}
                            value={formData.plan}
                            onChange={(event, value) => handleChange(event, value, 'plan')}
                            renderInput={(params) => (
                                <TextField {...params} label="Plan" sx={{ height: "56px" }} />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <Autocomplete
                            fullWidth
                            multiple
                            disablePortal
                            options={frequencyOptions}
                            value={formData.frequency || []}
                            onChange={(event, value) => handleChange(event, value, 'frequency')}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Frequency"
                                    placeholder="Select Frequency"
                                    sx={{ height: "56px" }}
                                />
                            )}
                        />
                    </Grid>

                    <Grid item xs={12} md={3}>
                        <TextField
                            fullWidth
                            label="Per Credit"
                            type="text"
                            value={formData.perCredit}
                            onChange={(e) => handleChange(e, null, 'perCredit')}
                            sx={{ height: "56px" }}
                        />
                    </Grid>
                    <Grid item xs={12} display="flex" justifyContent="flex-end" sx={{ mt: 2 }}>
                        <Button variant="contained" color="primary" onClick={handleSubmit}>
                            Add
                        </Button>
                    </Grid>
                </Grid>
            </Card>
            {submittedData.length > 0 && (
                <Card elevation={3} sx={{ p: 2, mt: 2 }}>
                    <Box sx={{ height: 400, width: "100%" }}>
                        <DataGrid
                            rows={rows}
                            columns={columns}
                            pageSize={5}
                            rowsPerPageOptions={[5, 10, 20]}
                        />
                    </Box>
                </Card>
            )}
        </Box>
    );
};

export default Communication;
